import React, { FC } from 'react';
import ComingSoonSignals from './coming-soon-signals';

const CACSignals: FC = () => {
	return <ComingSoonSignals signal="cac" />;
};

export default CACSignals;
